import Backbone from '@polleverywhere/backbone'
import { html, render } from 'lit-html'

import '@polleverywhere/pe-password-field'

export default class PasswordField extends Backbone.View {
  get className () {
    return 'component-auth__password-field'
  }

  get $input () {
    return this.$('input')
  }

  get field () {
    return this.$('pe-password-field')[0]
  }

  get name () {
    return 'password'
  }

  initialize (options = {}) {
    this.options = Object.assign({}, {
      current: false,
      required: true
    }, options)
  }

  toggleError (error) {
    this.field.error = error
  }

  validate () {
    return this.field.validate()
  }

  render () {
    render(html`
    <pe-password-field
      ?required=${this.options.required}
      name=${this.name}
      placeholder=Password
      ?current=${this.options.current}
      @invalid=${(...args) => this.trigger('error', ...args)}
      @input=${() => this.validate()}
    ></pe-password-field>
    `, this.el)

    return this
  }
}
